import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable(
  {
    providedIn: 'root'
  }
)

export class ReloadService {
  private reloadListSubject = new Subject<void>();
  reloadList$ = this.reloadListSubject.asObservable();

  triggerReload() {
    this.reloadListSubject.next();
  }
}
